import { render, staticRenderFns } from "./aboutInvestBanner.vue?vue&type=template&id=081cf644&scoped=true"
import script from "./aboutInvestBanner.vue?vue&type=script&lang=js"
export * from "./aboutInvestBanner.vue?vue&type=script&lang=js"
import style1 from "./aboutInvestBanner.vue?vue&type=style&index=1&id=081cf644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081cf644",
  null
  
)

export default component.exports